import {
   ChangeDetectionStrategy,
   Component,
   Inject,
   OnDestroy,
   OnInit,
   ViewChild,
   ViewEncapsulation,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CallState } from '@lcs/shared/api';
import { Store, select } from '@ngrx/store';
import { Providers } from 'generated/graphql-types';
import { Observable, Subject } from 'rxjs';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { FormComponent } from 'src/app/common-components/forms-base/form-component.interface';
import { getAddPhoneNumberCallState } from 'src/app/pages/add-phone-number/state/add-phone-number.selectors';
import { PhoneNumberDetailFormService } from '../../phone-number-details/services/phone-number-detail-form.service';
import { AddPhoneNumberData } from '../models/add-phone-number-data';
import { createPhoneNumber, createPhoneNumberAndAddAnother } from '../state/add-phone-number.actions';
import { AddPhoneNumberViewComponent } from '../views/add-phone-number-view.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [PhoneNumberDetailFormService],
    selector: 'ndt-add-phone-number',
    styleUrls: ['./add-phone-number.component.scss'],
    templateUrl: './add-phone-number.component.html',
    standalone: false
})
export class AddPhoneNumberComponent implements OnInit, OnDestroy, FormComponent {
   @ViewChild(AddPhoneNumberViewComponent) AddPhoneNumberViewComponent: AddPhoneNumberViewComponent;

   callState: Observable<CallState>;

   form: UntypedFormGroup;

   private destroyed$ = new Subject<void>();

   constructor(
      protected store: Store,
      protected formService: PhoneNumberDetailFormService,
      protected router: Router,
      @Inject(MAT_DIALOG_DATA) public data: AddPhoneNumberData,
      private dialogService: LcsDialogService
   ) {
      this.callState = this.store.pipe(select(getAddPhoneNumberCallState));
   }

   ngOnInit(): void {
      this.form = this.formService.form;
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   onCloseClick(): void {
      this.dialogService.close();
   }

   onCreate(): void {
      if (this.form.valid) {
         this.store.dispatch(
            createPhoneNumber({
               phoneNumber: this.formService.getValue(null),
            })
         );
      }
   }

   onCreateAndAddAnother(): void {
      if (this.form.valid) {
         this.store.dispatch(
            createPhoneNumberAndAddAnother({
               phoneNumber: this.formService.getValue(null),
               accountName: this.form.get('account')?.value?.name ?? null,
            })
         );
      }
   }

   providerDisplayWith(option: Providers): string {
      return `${option ?? ''}`;
   }
}
